import {applyMiddleware, createStore, compose} from "redux";
import {fromJS, Map} from "immutable";

import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware'
import {apiCall} from './middleware/apiCall'
import reducers from "./reducers";

import {defState as cartDefState} from "./reducers/cartReducer";

const getState = (localState) => {
    return {
        ...localState, cart: {...cartDefState, ...localState.cart}
    }
};

const persistedState = localStorage.getItem('LoguNoliktavaSavedState') ? fromJS(
    getState(JSON.parse(localStorage.getItem('LoguNoliktavaSavedState'))
    )) : Map();
/*const middleware = applyMiddleware(apiCall, promise(), thunk, createLogger());


export default createStore(reducers, persistedState, middleware);*/

const middlewareArray = [
    apiCall, promise(), thunk,
];

if (process.env.NODE_ENV === 'development') {
    middlewareArray.push(createLogger());
}

const middleware = applyMiddleware(...middlewareArray);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(reducers, persistedState, composeEnhancers(middleware));


